import { ALLOW_TEST_LOGIN, BW_PHANT_URL } from '../config';
import LogoutService from './logout.service';
import StorageService, { TEST_USER_ID } from './storage.service';
import { ApiError } from 'src/utils/error.utils';

export default class BWDataService {
    public static baseHeaders(): Headers {
        const headers: Headers = new Headers();
        headers.append('Content-Type', 'application/json');
        if (ALLOW_TEST_LOGIN) {
            headers.append('Authorization', StorageService.getTestUserId());
        }
        return headers;
    }

    public static clearUser(): void {
        StorageService.removeReduxUser();
    }

    protected static async logoutUser(): Promise<void> {
        StorageService.remove(TEST_USER_ID, null);
        LogoutService.handleLogoutRedirect();
    }

    protected static async handleResponse(response: Response, returnRaw?: boolean): Promise<any> {
        if (response.status === 200 && response.headers.get('Content-Type') === 'text/html')
            throw new ApiError(response, 'Received an error page html');

        if (returnRaw) return response;

        return await response.text().then((text: string) => {
            if (!response.ok) throw new ApiError(response);
            return text && JSON.parse(text);
        });
    }

    protected static async get(url: string): Promise<any> {
        const requestOptions = {
            method: 'GET',
            headers: this.baseHeaders(),
            credentials: 'include' as const
        };

        return await fetch(this.fullUrl(url, 'get'), requestOptions).then(this.handleResponse);
    }

    protected static async putRaw(url: string, payload: any): Promise<any> {
        const requestOptions = {
            method: 'PUT',
            headers: this.baseHeaders(),
            body: JSON.stringify(payload),
            credentials: 'include' as const
        };

        return await fetch(this.fullUrl(url, 'put'), requestOptions).then(
            async (res) => await this.handleResponse(res, true)
        );
    }

    protected static async deleteRaw(url: string): Promise<any> {
        const requestOptions = {
            method: 'DELETE',
            headers: this.baseHeaders(),
            credentials: 'include' as const
        };

        return await fetch(this.fullUrl(url, 'delete'), requestOptions).then(
            async (res) => await this.handleResponse(res, true)
        );
    }

    protected static async put(url: string, payload: any): Promise<any> {
        const requestOptions = {
            method: 'PUT',
            headers: this.baseHeaders(),
            body: JSON.stringify(payload),
            credentials: 'include' as const
        };

        return await fetch(this.fullUrl(url, 'put'), requestOptions).then(this.handleResponse);
    }

    protected static async postJpeg(url: string, image: Blob): Promise<any> {
        const requestOptions = {
            method: 'POST',
            headers: this.baseHeaders(),
            body: image,
            credentials: 'include' as const
        };

        return await fetch(this.fullUrl(url, 'post'), requestOptions).then(this.handleResponse);
    }

    protected static async post(url: string, payload: any): Promise<any> {
        const requestOptions = {
            method: 'POST',
            headers: this.baseHeaders(),
            body: JSON.stringify(payload),
            credentials: 'include' as const
        };

        return await fetch(this.fullUrl(url, 'post'), requestOptions).then(this.handleResponse);
    }

    protected static async postFormData(url: string, formData: FormData): Promise<any> {
        const requestOptions = {
            method: 'POST',
            headers: this.baseHeaders(),
            body: formData,
            credentials: 'include' as const
        };

        return await fetch(this.fullUrl(url, 'post'), requestOptions).then(this.handleResponse);
    }

    protected static async delete(url: string): Promise<any> {
        const requestOptions = {
            method: 'DELETE',
            headers: this.baseHeaders(),
            credentials: 'include' as const
        };

        return await fetch(this.fullUrl(url, 'delete'), requestOptions).then(this.handleResponse);
    }

    /** _action parameter is ignored */
    private static fullUrl(uri: string, _action: string): string {
        return `${BW_PHANT_URL}${uri}`;
    }
}
